import React, { Component } from "react";
import {
  Icon,
  Row,
  Modal,
  Button,
  Spin,
  Input,
  message,
  AutoComplete,
} from "antd";
import axios from "axios";
import { Translate } from "react-translated";
import F from "../Functions";
import ConfirmationModal from "./confirmation-modal";
import DataHandler from "../utils/DataHandler";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: false,
    agency_id: null,
    action: "add_manually",
    cols: [],
    form: {
      phone: "",
    },
    form_error: {
      phone: "",
    },
    ordered_cols: {
      phone: "",
    },
    showUploadListConfirmationModal: false,
  };

  updateField = (name, value) => {
    const { form } = this.state;
    form[name] = value;
    this.setState({ form });
  };

  uploadCustomer = () => {
    const data = this.state.form;
    data.agency_id = this.state.agency_id;

    // new add
    data.phone = F.removeFormatterFromPhoneNumber(data.phone);

    this.setState({
      loading: true,
    });

    axios
      .post("/api/add_customer_to_dnc_list", data)
      .then((res) => {
        this.setState((prevState) => {
          const form = {
            ...prevState.form,
            phone: "",
          };
          return {
            loading: false,
            form,
          };
        });

        const response = res.data;

        if (response.success) {
          message.success(response.message);

          // handle callback
          const callback = DataHandler.getDncCustomerCallback();
          callback && callback();
        } else {
          message.error(response.message);
        }

        this.props.hideModal();
      })
      .catch((error) => {
        F.log(error);
        this.setState({
          loading: false,
        });
      });
  };

  validateFieldsSuccess = () => {
    const { agency_id } = this.state;

    // reset notification
    message.destroy();

    if (agency_id === null) {
      message.error(F.translate(`Please select an Agency.`));
      return false;
    }

    const data = this.state.form;

    if (!data.phone) {
      message.error(F.translate("Phone number is required"));
      return false;
    }

    // validate regix
    if (!F.validatePhoneRegix(data.phone)) {
      message.error(F.translate("Phone is Invalid"));
      return false;
    }

    return true;
  };

  save = () => {
    // reset notification
    message.destroy();

    if (this.validateFieldsSuccess()) {
      this.setState({ showUploadListConfirmationModal: true });
    }
  };

  renderFooter = () => {
    return (
      <div>
        <Button type="primary" onClick={() => this.save()}
          className="bg-164897 borderRadius-28"
        >
          <Translate text={`Upload`} />
        </Button>
        <Button onClick={() => this.props.hideModal()}
          className="borderRadius-28"
        >
          <Translate text={`Cancel`} />
        </Button>
      </div>
    );
  };

  clearFormField = () => {
    this.updateField("phone", "");
  };

  onSelectAgency = (val) => {
    // handle crash for empty value "select" from the drop down
    if (typeof val === "string" && val === "") {
      this.setState({
        agency_id: null,
      });
    } else {
      let item = this.props.adminAgenciesList.find((user) => user.name === val);
      if (item && Object.keys(item).length > 0) {
        this.setState({
          select: val,
          agency_id: item.id,
        });
      }
    }
    this.clearFormField();
  };

  renderAgencyDropDown = () => {
    const dataSource = this.props.adminAgenciesList.map((user) => user.name);

    return (
      <div style={{ marginBottom: 10 }}>
        <label>
          <Translate text={`Agency`} />
        </label>
        <AutoComplete
          style={{ width: "100%" }}
          dataSource={dataSource}
          placeholder="Select"
          onSelect={this.onSelectAgency}
          onSearch={this.onSelectAgency}
          allowClear
          filterOption={(inputValue, option) =>
            option.props.children
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
        />
      </div>
    );
  };
  renderPhoneField = () => {
    const { form, agency_id } = this.state;

    return agency_id !== null ? (
      <Row>
        <div className="inputField">
          <label>
            {/* <Translate text={`Phone`} /> * */}
            <Translate text={`Phone`} /> <span className="required-symbol">*</span>
          </label>
          <Input
            value={F.phone_format(form.phone)}
            // type="text"
            // maxLength={11}
            // onChange={(e) =>
            //   this.updateField("phone", e.target.value)
            // }
            onChange={(e) => {
              if (e.target.value.trim().length <= 14) {
                const updateNumber = F.phone_format(e.target.value);
                // F.log("noor 3 " + updateNumber);
                this.updateField("phone", updateNumber);
              }
            }}
          />
        </div>
      </Row>
    ) : null;
  };

  onConfirmedUploadFile = () => {
    this.setState({ showUploadListConfirmationModal: false }, () => {
      this.uploadCustomer();
    });
  };

  onCancelUploadFile = () => {
    this.setState({ showUploadListConfirmationModal: false });
  };

  render() {
    const { loading } = this.state;

    return (
      <Modal
        title={<Translate text={`Upload DNC Customer`} />}
        visible={this.props.showModal}
        onCancel={this.props.hideModal}
        footer={this.renderFooter()}
      >
        <Spin indicator={antIcon} spinning={loading}>
          <div className="formBox">
            {this.renderAgencyDropDown()}

            {this.renderPhoneField()}
          </div>
        </Spin>
        <ConfirmationModal
          showModal={this.state.showUploadListConfirmationModal}
          title="Confirmation"
          okText="Yes"
          cancelText="No"
          message="Are you sure you want to move customer to the DNC list?"
          ok={this.onConfirmedUploadFile}
          cancel={this.onCancelUploadFile}
        />
      </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/components/upload-dnc-customer.js